import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getRedirectRoute } from 'selectors/redirect';
import { clearRedirectRoute } from 'actions/redirect';

const GlobalRedirect = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const clear = useCallback(() => dispatch(clearRedirectRoute()), [dispatch]);
    const redirectRoute = useSelector(getRedirectRoute);

    useEffect(() => {
        if (redirectRoute) {
            navigate(redirectRoute);
            clear();
        }
    }, [redirectRoute, clear, navigate]);

    return <></>;
};

export default GlobalRedirect;
